import Vue from 'vue';

// Load global components
import Navigation from '@/components/Navigation.vue';

Vue.component('Navigation', Navigation);
